
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import React, { useState, useEffect } from 'react'
import Home from './Home';
import Chart from "./Chart";
import axios from 'axios'

function App() {
  const [latestStats, setLatestStats] = useState("loading")
  const fetchLatestStats = () => {
    axios.get('https://zbachn9r0f.execute-api.ap-southeast-1.amazonaws.com/default/afs-fetch-latest').then(
      res => setLatestStats(res.data)
    )
  }

  useEffect(() => {
    fetchLatestStats()
  }, [])
  return (
    <Router>
      <div className="App">
        <header className="App-header">
            <div className="z-10 order-2 md:order-1 w-11/12 h-full md:w-3/4 flex flex-wrap items-center -mt-6 md:mt-0">
                <div className="min-w-full p-8 md:pr-14 md:pl-14 md:py-12 mx-0 md:mx-0 h-full bg-purple-50 rounded-2xl shadow-xl">
                  <Switch>
                    <Route exact path="/">
                      <Home 
                      stats={latestStats}
                      refreshStats={() => fetchLatestStats()}/>
                    </Route>
                    <Route exact path="/chart">
                      <>
                      <Chart stats={latestStats}/>
                      </>
                    </Route>
                  </Switch>        
                </div>
            </div>
        </header>
      </div>
    </Router>


  );
}

export default App;
